<template>
  <div style="padding-top: 60px;">
    <div class="header">
      <div class="width1200 el-row--flex is-justify-space-between is-align-middle">
        <img src="/static/images/logo.png" alt="首页" class="logo">
        <div class="el-row--flex is-align-middle">
          <el-menu :default-active="this.$route.path" class="el-menu-demo" router mode="horizontal">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/aboutus">关于我们</el-menu-item>
            <el-menu-item index="/product">产品中心</el-menu-item>
            <el-menu-item index="/solution">解决方案</el-menu-item>
            <el-menu-item index="/news">新闻动态</el-menu-item>
            <!-- <el-menu-item index="/cooperation">商务合作</el-menu-item> -->
            <el-menu-item index="/contactus">联系我们</el-menu-item>
            <el-menu-item index="/service/access">技术服务</el-menu-item>
          </el-menu>
          <div v-if="!loginStatus" class="login-btn el-row--flex is-justify-center is-align-middle" @click="to('/login')">
            <span>登录</span>
          </div>
          <div v-else class="user el-row--flex is-justify-center is-align-middle" @mouseenter="userLayerShow = true" @mouseleave="hideUserLayer">
            <img src="/static/images/default-header.png" >
            <div class="userLayer" v-if="userLayerShow" @mouseenter="userLayerMousein" @mouseleave="userLayerMouseout">
              <div class="userLayerTitle el-row--flex is-align-middle">
                <span>{{userName}}</span>
              </div>
              <div class="userLayerAction el-row--flex is-justify-center is-align-middle" @click="to('/user')">
                <img src="/static/images/icon/icon-user-center.png" >
                账户中心
              </div>
              <div class="userLayerAction el-row--flex is-justify-center is-align-middle" @click="logout">
                <img src="/static/images/icon/icon-logout.png" >
                退出登录
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div class="bottom el-row--flex is-justify-center is-align-middle">
      <span @click="toexternal('https://beian.miit.gov.cn')">
        ICP备案号：浙ICP备11032253号-3
      </span>
      <span>
        地址：浙江省杭州市萧山区市心北路108号5005D
      </span>
    </div>
    <el-dialog
      class="recharge"
      title="充值中心"
      :visible.sync="rechargeShow"
      width="900px"
      :before-close="handleClose">
      <div class="rechargeTitle">选择充值金额(元)</div>
      <div class="rechargeItem el-row--flex is-justify-space-between">
        <div :class="{active: rechargeTab == 0}" @click="rechargeTab = 0">{{ $global.tabMatchAmount(0) }}</div>
        <div :class="{active: rechargeTab == 1}" @click="rechargeTab = 1">{{ $global.tabMatchAmount(1) }}</div>
        <div :class="{active: rechargeTab == 2}" @click="rechargeTab = 2">{{ $global.tabMatchAmount(2) }}</div>
        <div :class="{active: rechargeTab == 3}" @click="rechargeTab = 3">{{ $global.tabMatchAmount(3) }}</div>
        <div :class="{active: rechargeTab == 4}" @click="rechargeTab = 4">
          <el-input type="number" v-model="amount" placeholder="自定义"></el-input>
        </div>
      </div>
      <div class="rechargeContent el-row--flex">
        <div>
          实付金额：
          <span><span>{{ rechargeTab === 4 ? amount : $global.tabMatchAmount(rechargeTab) }}</span>元</span>
        </div>
        <div class="el-row--flex is-align-middle">
          支付方式：
          <img src="/static/images/icon/icon-alipay.png" >
        </div>
      </div>
      <div class="rechargeTip el-row--flex is-justify-space-between">
        单次充值金额 3000 ~ 4999，赠送充值金额的10%；充值金额 5000 ~ 9999，赠送20%；充值金额 10000及以上，赠送30%。
      </div>
      <div class="el-row--flex">
        <el-button type="primary" class="rechargeBtn" @click="recharge">立即支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    data() {
      return {
        userLayerShow: false,
        userLayerFlag: false,
        userName: '',
        rechargeTab: 0,
        amount: '',
      }
    },
    created() {
      if (localStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))));
      }

      window.addEventListener('beforeunload', () => {
        localStorage.setItem('store' , JSON.stringify(this.$store.state));
      })
    },
    mounted() {
      this.refresh();
    },
    methods: {
      toexternal(url) {
        window.open(url);
      },
      to(path) {
        if (this.$router.history.current.path != path) {
          this.$router.push(path);
        } else {
          location.reload();
        }
      },
      refresh() {
        this.$global.axios.post(this, '/sywl/api/user/userInfo', {}, res => {
          this.userName = res.data.userName;
        })
      },
      hideUserLayer() {
        const that = this;
        setTimeout(function(){
          if (!that.userLayerFlag) {
            that.userLayerShow = false;
          }
        }, 100)
      },
      userLayerMousein() {
        this.userLayerFlag = true;
      },
      userLayerMouseout() {
        this.userLayerFlag = false;
      },
      logout() {
        this.$global.axios.post(this, '/sywl/api/user/logout', {}, res => {
          this.$message.success('账号状态已过期，请重新登录');
          this.$store.commit('loginChange', false);
          this.$router.push('/login');
        })
      },
      handleClose() {
        this.$store.commit('rechargeChange');
      },
      recharge() {
        if (this.rechargeTab === 4 && this.amount === '') {
          this.$message.warning('请输入需要充值的金额')
        } else if (this.rechargeTab === 4 && this.amount <= 0) {
          this.$message.warning('请输入正确的充值金额')
        } else {
          window.open(`/pay?price=${ this.rechargeTab === 4 ? this.amount : this.$global.tabMatchAmount(this.rechargeTab) }&type=3`);
          this.$store.commit('rechargeChange');
          this.$confirm('是否完成支付？', {
            confirmButtonText: '我已支付',
            cancelButtonText: '稍后再说',
            center: true
          }).then(() => {
            if (location.pathname == '/user') {
              location.reload();
            }
          }).catch(info => {})
        }
      }
    },
    computed: {
      ...mapState(['rechargeShow', 'loginStatus']),
    },
    watch: {
      loginStatus(n) {
        if (n) {
          this.refresh();
        }
      },
      $router(e, n) {
        console.log(e,n);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 0 5px rgba($color: #000000, $alpha: .5);

    .login-btn {
      width: 60px;
      height: 32px;
      border: 1px solid #1875f0;
      border-radius: 4px;
      font-size: 15px;
      color: #1875f0;
    }

    .user {
      position: relative;
      margin: 0 30px;

      &Layer {
        position: absolute;
        right: -30px;
        bottom: -109px;
        width: 122px;
        height: 109px;
        background-color: #fff;
        border-radius: 6px;
        box-shadow: 5px 5px 10px 10px rgba($color: #909090, $alpha: .15);

        &Title {
          height: 36px;
          padding: 0 5px;
          border-bottom: 1px solid #e2e2e2;
          font-size: 14px;
          color: #666;
        }

        &Action {
          margin-top: 11px;
          font-size: 14px;
          color: #666;
          cursor: pointer;

          img {
            width: 14px;
            height: 14px;
            margin-right: 12px;
          }
        }
      }
    }
  }

  .el-menu-demo {
    border: none!important;

    & > .el-menu-item,
    & .el-submenu__title {
      padding: 0 12px;
      color: #333;

      &.is-active {
        color: #1875f0;
        border-width: 4px;
        border-color: #1875f0;
      }
    }
  }

  .bottom {
    height: 53px;
    font-size: 15px;
    color: #fff;
    line-height: 53px;
    background-color: #1A2129;
    user-select: none;

    span {
      margin-left: 10px;
    }
  }

  .recharge {
    & /deep/ .el-dialog__header {
      background-color: #000;
      text-align: left;
      color: #fff;

      .el-dialog__title {
        color: #fff;
      }
    }

    & /deep/ .el-dialog__body {
      padding: 44px 94px 158px 57px;
    }

    &Title {
      font-size: 18px;
      text-align: left;
      color: #333;
    }

    &Item {
      & > div {
        width: 140px;
        height: 101px;
        margin-top: 30px;
        border: 1px solid #eaeaea;
        border-radius: 10px;
        font-size: 40px;
        font-weight: bold;
        font-style: italic;
        color: #333;
        line-height: 101px;
        overflow: hidden;

        &.active {
          position: relative;
          background: #DFEBFF;
          border: 1px solid #1875F0;
          box-shadow: 0px 6px 8px 0px rgba(24, 117, 240, 0.3);

          &::after {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            width: 41px;
            height: 41px;
            background: url('/static/images/icon/icon-recharge-acttive.png');
          }
        }

        & /deep/ .el-input {
          display: block;
          height: 100%;

          .el-input__inner {
            display: block;
            height: 100%;
            border: none;
            font-size: 32px;
          }
        }
      }
    }

    &Content {
      height: 76px;
      margin-top: 20px;
      align-items: baseline;
      font-size: 16px;
      line-height: 76px;
      color: #333;
      border-bottom: 1px dashed #dcdcdc;

      div + div {
        margin-left: 76px;
      }

      span {
        color: red;

        span {
          margin-right: 5px;
          font-size: 28px;
          font-weight: bold;
        }
      }
    }

    &Tip {
      padding: 40px 0;
      font-size: 18px;
      font-weight: 600;
      text-align: left;
    }

    &Btn {
      margin-top: 33px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue